import defaultLibraryMap from '../../../../lib/default-library-map';
import getCustomComponents from '../get-custom-components';

const getCustomComponentsLibraryMaps = config => {
  const customComponentsMap = getCustomComponents(config);
  return [customComponentsMap, defaultLibraryMap];
};

export default getCustomComponentsLibraryMaps;
